import { render, staticRenderFns } from "./OfferComposition.vue?vue&type=template&id=7c4ba3de&scoped=true"
import script from "./OfferComposition.vue?vue&type=script&lang=js"
export * from "./OfferComposition.vue?vue&type=script&lang=js"
import style0 from "./OfferComposition.vue?vue&type=style&index=0&id=7c4ba3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ba3de",
  null
  
)

export default component.exports